/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-useless-concat */

import { ApexOptions } from "apexcharts";
import { YrangeProp } from "../../Type/DashboardType";
import ConfigDB from "../../config/ThemeConfig";

const darkcolor = ConfigDB.data.color.dark_color;
const lightcolor = ConfigDB.data.color.light_color;

export const ADD_PRODUCT_DATA = ["ribbon1.png", "ribbon2.png", "ribbon1.png", "ribbon2.png", "ribbon1.png", "ribbon2.png", "ribbon3.png", "ribbon4.png"];

export const WEEKLY_VISITOR_OPTION: ApexOptions = {
  series: [
    {
      name: "Average : 26,546 ",
      data: [20, 120, 40, 30, 65, 120, 44],
    },
  ],
  chart: {
    height: 300,
    type: "radar",
    toolbar: {
      show: false,
    },
  },
  legend: {
    show: true,
  },
  plotOptions: {
    radar: {
      size: 110,
      offsetY: -20,
      polygons: {
        strokeColors: "#e9e9e9",
        fill: {
          colors: [lightcolor, "#fff"],
        },
      },
    },
  },
  title: {
    text: "Average : 26,546",
    align: "center",
    offsetY: 272,
    style: {
      fontSize: "16px",
      fontWeight: "400",
      fontFamily: "Secular One",
      color: "#1F2F3E",
    },
  },
  labels: ["Average : 26,546 "],
  colors: [darkcolor],
  markers: {
    size: 5,
    colors: ["#fff"],
    strokeColors:darkcolor,
    strokeWidth: 3,
  },
  tooltip: {
    custom: function ({ series, seriesIndex, dataPointIndex, w }) {
      var data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
      return '<ul class="p-2">' + "<li><b>visitors</b>: " + w.globals.labels[dataPointIndex] + "</li>" + "</ul>";
    },
  },
  xaxis: {
    categories: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  },
  yaxis: {
    show: false,
  },
  responsive: [
    {
      breakpoint: 1446,
      options: {
        plotOptions: {
          radar: {
            size: 90,
          },
        },
      },
    },
    {
      breakpoint: 1334,
      options: {
        plotOptions: {
          radar: {
            size: 70,
          },
        },
      },
    },
    {
      breakpoint: 1200,
      options: {
        plotOptions: {
          radar: {
            size: 110,
          },
        },
      },
    },
    {
      breakpoint: 405,
      options: {
        plotOptions: {
          radar: {
            size: 90,
          },
        },
      },
    },
    {
      breakpoint: 360,
      options: {
        plotOptions: {
          radar: {
            size: 68,
          },
        },
      },
    },
  ],
};

export const TOTAL_DETAILS_DATA = [
  {
    md: "12",
    class: "profit-card",
    title: "Total Users",
    data: "6542",
    progress: "35",
    progressColor: "primary",
    image: "users.png",
    icon: "sort-desc",
    iconClass: "down-icon",
    profit: "- 12.32%",
    profitColor: "secondary",
  },
  {
    md: "6",
    class: "orders-card",
    title: "Total Orders",
    data: "659",
    progress: "45",
    progressColor: "secondary",
    image: "order.png",
    icon: "sort-up",
    iconClass: "up-icon",
    profit: "+ 12.32%",
    profitColor: "primary",
  },
  {
    md: "6",
    class: "products-card",
    title: "Total Products",
    data: "719",
    progress: "65",
    progressColor: "dark",
    image: "product.png",
    icon: "sort-up",
    iconClass: "up-icon",
    profit: "+ 12.32%",
    profitColor: "dark",
  },
];

// Bubble cahrt
function generateData(baseval:number, count: number, yrange:YrangeProp) {
  var i = 0;
  var series = [];
  while (i < count) {
    var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
    var z = Math.floor(Math.random() * (75 - 15 + 1)) + 15;
    series.push([baseval, y, z]);
    baseval += 86400000;
    i++;
  }
  return series;
}

export const SALES_SUMMARY_DATA: ApexOptions = {
  chart: {
    height: 400,
    type: "bubble",
    toolbar: {
      show: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  series: [
    {
      name: "Product1",
      data: generateData(new Date("01 Jan 2023 GMT").getTime(), 20, {
        min: 10,
        max: 55,
      }),
    },
    {
      name: "Product2",
      data: generateData(new Date("01 Jan 2023 GMT").getTime(), 20, {
        min: 10,
        max: 55,
      }),
    },
    {
      name: "Product3",
      data: generateData(new Date("01 Jan 2023 GMT").getTime(), 20, {
        min: 10,
        max: 55,
      }),
    },
    {
      name: "Product4",
      data: generateData(new Date("01 Jan 2023 GMT").getTime(), 20, {
        min: 10,
        max: 55,
      }),
    },
  ],
  fill: {
    type: "gradient",
  },
  legend: {
    show: false,
  },
  xaxis: {
    tickAmount: 12,
    type: "datetime",
    labels: {
      rotate: 0,
    },
  },
  yaxis: {
    labels: {
      formatter: function (value) {
        return value + "K";
      },
      style: {
        colors: [darkcolor],
        fontFamily: "Secular One",
      },
    },
  },
  theme: {
    palette: "palette2",
  },
  colors: ["#1F2F3E", "#C1E9C1", "#1F2F3E", "#C1E9C1"],
  tooltip: {
    custom: function ({ series, seriesIndex, dataPointIndex, w }) {
      return '<ul class="p-2">' + "<li><b>Order</b>: " + w.globals.labels[dataPointIndex] + "</li>" + "</ul>";
    },
  },
};

export const TRACK_ORDER_DATA = [
  {
    image: "1.png",
    tag: "Order Placed",
    text: "We have received Your Order",
    span: "Jun20 05:40PM",
    imageClass: "bg-dark",
  },
  {
    image: "2.png",
    tag: "Order Packed",
    text: "Your Product Packed and ready to shipped",
    span: "Jun22 06:30PM",
    imageClass: "bg-dark",
  },
  {
    image: "3.png",
    tag: "On the way",
    text: "Your Ordeis placed successfully.",
    span: "July 20",
  },
  {
    image: "4.png",
    tag: "Product Deliverd",
    text: "Our courier partner will deliver our stuff on July 3, 2023...",
  },
];

export const SELLIND_PRODUCT_DATA = ["UID", "Product", "Category", "Brand", "Price", "Stock", "Rating", "Order", "Sales", "Action"];

export const SELLIND_PRODUCT_COLUMN = [
  {
    id: 1,
    uid: "#1",
    imageSrc: "01.png",
    productName: "Samsung TV",
    category: "Women’s",
    brand: "Richman",
    price: "$20.00",
    stock: 265,
    rating: "2.5",
    ratingCount: 16,
    order: 165,
    sales: "35K",
  },
  {
    id: 2,
    uid: "#2",
    imageSrc: "02.png",
    productName: "Leather Belt",
    category: "Men’s",
    brand: "Lubhauo",
    price: "$16.00",
    stock: 954,
    rating: "4.5",
    ratingCount: 16,
    order: 789,
    sales: "95K",
  },
  {
    id: 3,
    uid: "#3",
    imageSrc: "03.png",
    productName: "Male Suit",
    category: "Women’s",
    brand: "Cameron",
    price: "$34.00",
    stock: 123,
    rating: "2.5",
    ratingCount: 16,
    order: 348,
    sales: "19K",
  },
  {
    id: 4,
    uid: "#4",
    imageSrc: "04.png",
    productName: "Female Dress",
    category: "Women’s",
    brand: "Wilson",
    price: "$34.00",
    stock: 756,
    rating: "2.5",
    ratingCount: 16,
    order: 956,
    sales: "20K",
  },
];

export const MANAGE_ORDER_DATA = ["Product Name", "Product Id", "Email Id", "Stock", "Payment", "Amount", "Status"];

export const MANAGE_ORDER_COLUMN = [
  {
    image: "01.png",
    title: "Samsung TV",
    spanText: "New Year Offer",
    productId: "#746628",
    mail: "mewoba4536@haboty.com",
    stock: 4561,
    payment: "Paid",
    amount: "$321.00",
    status: "Done",
  },
  {
    image: "02.png",
    title: "Spring Bed",
    spanText: "Bought item",
    productId: "#514295",
    mail: "teyox2345@haboty.com",
    stock: 5689,
    payment: "Paid",
    amount: "$123.00",
    status: "Pending",
  },
  {
    image: "03.png",
    title: "Long Dress",
    spanText: "Bought item",
    productId: "#325679",
    mail: "jisom63678@ekbasia.com",
    stock: 2528,
    payment: "Paid",
    amount: "$622.00",
    status: "Done",
  },
  {
    image: "04.png",
    title: "Phillip Lightbulb",
    spanText: "Item Sold",
    productId: "#956217",
    mail: "tenih4573@ekbasia.com",
    stock: 3254,
    payment: "Paid",
    amount: "$621.00",
    status: "Cancel",
  },
];

export const OVER_RATING_STAR = [
  {
    rate: "4.5",
    percentage: "95%",
  },
  {
    rate: "6.2",
    percentage: "61%",
  },
  {
    rate: "5.0",
    percentage: "34%",
  },
  {
    rate: "1.3",
    percentage: "91%",
  },
];

export const TRANSACTION_DATA_TABLE = [
  {
    heading: [
      {
        text: "Item Name",
      },
      {
        text: "Date And Time",
        classname: "text-truncate",
      },
      {
        text: "Amount",
      },
      {
        text: "Invoice no.",
        classname: "text-truncate",
      },
      {
        text: "Status",
      },
      {
        text: "Payment",
      },
    ],
    items: [
      {
        image: "01.png",
        title: "Samsung TV",
        spanText: "Item Sold",
        date: "Jan 25, 2022",
        time: "08:35:65",
        amount: "$875 USD",
        code: "#px0101",
        color: "primary",
        value: "75",
        payment: "Paypal",
      },
      {
        image: "02.png",
        title: "Spring Bed",
        spanText: "Bought item",
        date: "Feb 20, 2022",
        time: "12:35:00",
        amount: "$564 USD",
        code: "#rf304f",
        color: "secondary",
        value: "25",
        payment: "Credit Card",
      },
      {
        image: "03.png",
        title: "Long Dress",
        spanText: "Bought item",
        date: "Oct 25, 2022",
        time: "04:39:08",
        amount: "$985 USD",
        code: "#dnj480",
        color: "success",
        value: "60",
        payment: "Paypal",
      },
      {
        image: "04.png",
        title: "Phillip Lightbulb",
        spanText: "Item Sold",
        date: "Dec 27, 2022",
        time: "08:35:65",
        amount: "$745 USD",
        code: "#g189d0",
        color: "warning",
        value: "45",
        payment: "Credit Card",
      },
    ],
  },
];

export const USER_INFO_HEAD = ["Name", "Email Address", "Status", "Role", "Actions"];

export const USER_INFO_DATAS = [
  {
    id: 1,
    image: "05.jpg",
    title: "Dmitriy Groshev",
    spanText: "United Kingdom",
    email: "hello123@dribbble.com",
    color: "primary",
    status: "Invited",
    role: "Interface Designer",
  },
  {
    id: 2,
    image: "06.jpg",
    title: "Patrick Beverley",
    spanText: "Australia",
    email: "beverley.lac@gmail.co",
    color: "secondary",
    status: "Active",
    role: "Interface Designer",
  },
  {
    id: 3,
    image: "07.jpg",
    title: "Kevin Greem",
    spanText: "United Kingdom",
    email: "green4502@gmail.com",
    color: "primary",
    status: "Invited",
    role: "Project Manager",
  },
  {
    id: 4,
    image: "08.jpg",
    title: "William Barton",
    spanText: "Netherlands",
    email: "barton-will@gmail.com",
    color: "secondary",
    status: "Active",
    role: "Backend Engineer",
  },
];

export const AUDIT_LOG = [
  {
    status: "RP204_salesfores created",
    name: "Andre Sluczka",
    time: "2hr ago",
    iconbg: "bg-dark-color",
    icon: "fa-check-circle",
  },
  {
    status: "R304_salesforece undeployed",
    name: "Andre Sluczka",
    time: "4hr ago",
    iconbg: "bg-primary",
    icon: "fa-exclamation-circle",
  },
  {
    status: "R304_salesforece failed...",
    name: "Andre Sluczka",
    time: "10 Jun",
    iconbg: "bg-secondary",
    icon: "fa-times-circle",
  },
  {
    status: "New environment DEV created",
    name: "Andre Sluczka",
    time: "22 Oct",
    iconbg: "bg-dark-color",
    icon: "fa-check-circle",
  },
  {
    status: "Project salesforce created",
    name: "Andre Sluczka",
    time: "25 Oct",
    iconbg: "bg-dark-color",
    icon: "fa-check-circle",
  },
];

export const ECOMMERCE_RADIAL_DATA: ApexOptions = {
  series: [65],
  chart: {
    type: "radialBar",
    height: 280,
    offsetY: -10,
    sparkline: {
      enabled: true,
    },
  },
  plotOptions: {
    radialBar: {
      startAngle: -120,
      endAngle: 180,
      offsetY: 0,
      hollow: {
        size: "55%",
      },
      track: {
        background: lightcolor,
        strokeWidth: "90%",
        startAngle: 0,
        endAngle: 360,
      },
      dataLabels: {
        name: {
          show: false,
        },
        value: {
          fontSize: "30px",
          fontFamily: "'Secular One', sans-serif",
          fontWeight: 600,
        },
      },
    },
  },
  colors: [darkcolor],
  grid: {
    padding: {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    },
  },
  stroke: {
    lineCap: "round",
  },
  responsive: [
    {
      breakpoint: 1700,
      options: {
        chart: {
          height: 280,
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: "48%",
            },
            dataLabels: {
              value: {
                fontSize: "14px",
              },
            },
          },
        },
      },
    },
    {
      breakpoint: 1580,
      options: {
        chart: {
          height: 250,
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: "48%",
            },
            dataLabels: {
              value: {
                fontSize: "14px",
              },
            },
          },
        },
      },
    },
    {
      breakpoint: 1400,
      options: {
        chart: {
          height: 230,
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: "60%",
            },
            dataLabels: {
              value: {
                fontSize: "18px",
              },
            },
          },
        },
      },
    },
    {
      breakpoint: 876,
      options: {
        chart: {
          height: 230,
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: "60%",
            },
            dataLabels: {
              value: {
                fontSize: "18px",
              },
            },
          },
        },
      },
    },
    {
      breakpoint: 376,
      options: {
        chart: {
          height: 260,
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: "60%",
            },
            dataLabels: {
              value: {
                fontSize: "18px",
              },
            },
          },
        },
      },
    },
  ],
};

export const NEWS_UPDATE_DATA = [
  {
    image: "news-1.jpg",
    title: "Indonesian Navy Lauds Mental Perseverance of Teenager...",
    text: "Today’s News Headlines, Breaking...",
    time: "10 Min ago ",
  },
  {
    image: "news-2.jpg",
    title: "Why now may be the ‘golden age’ for Southeast asia start-ups...",
    text: "Check out the latest news from...",
    time: "8 Min ago ",
  },
  {
    image: "news-3.jpg",
    title: "China’s renewed crypto crackdown wipes nearly $400...",
    text: "Technology and indian business news...",
    time: "12 Min ago ",
  },
];

export const TRAFIC_CHART_DATA: ApexOptions = {
  series: [
    {
      type: "area",
      data: [50, 70, 65, 80, 40, 50, 48, 60, 48, 50, 70, 80, 75, 50, 60, 50, 50, 10, 30, 20, 70, 65, 95, 45, 70, 50, 80, 75, 90, 60, 65, 50, 70, 65, 50, 55, 50],
    },
  ],
  chart: {
    height: 35,
    type: "area",
    toolbar: {
      show: false,
    },
  },
  stroke: {
    curve: "smooth",
    width: [3, 1],
    dashArray: [0, 5],
  },
  annotations: {
    points: [
      {
        x: 347,
        y: 65,
        marker: {
          size: 8,
          fillColor: darkcolor,
          strokeColor: "#ffffff",
          strokeWidth: 5,
        },
      },
    ],
  },
  fill: {
    type: "gradient",
    gradient: {
      shadeIntensity: 1,
      opacityFrom: 0.5,
      opacityTo: 0.9,
      stops: [0, 100],
    },
  },
  responsive: [
    {
      breakpoint: 1470,
      options: {
        chart: {
          height: 230,
        },
      },
    },
    {
      breakpoint: 992,
      options: {
        chart: {
          height: 230,
        },
      },
    },
  ],
  yaxis: {
    show: false,
  },
  grid: {
    show: false,
  },
  xaxis: {
    labels: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    crosshairs: {
      show: true,
      width: 1,
      position: "back",
      stroke: {
        color: darkcolor,
        width: 1,
        dashArray: 5,
      },
    },
  },
  dataLabels: {
    enabled: false,
  },
  legend: {
    show: false,
  },
  tooltip: {
    custom: function ({ series, seriesIndex, dataPointIndex, w }) {
      return '<ul class="p-2">' +
        '<li><b>Price</b>: ' + w.globals.labels[dataPointIndex] + '</li>' +
        '</ul>';
    }
  },
  colors: [darkcolor],
};

export const TRAFIIC_DATA = [
  {
    amount: "$65.340",
    icon: "sort-up",
    span: "Store Visits",
    color: "",
  },
  {
    amount: "$65.340",
    iconClass: "down-icon",
    icon: "sort-desc",
    span: "Visitors",
    colorClass: "font-secondary",
  },
];

//  Sales Summary chart start
export const SALE_SUMMARY_DATA: ApexOptions = {
  series: [
    {
      name: "Activity",
      data: [4, 5, 5.7, 3, 5, 5.4, 5.8, 4, 4.5, 3, 5],
    },
  ],
  chart: {
    height: 320,
    type: "bar",
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      distributed: true,
      borderRadius: 3,
      columnWidth: "30%",
    },
  },
  dataLabels: {
    enabled: false,
  },
  xaxis: {
    categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov"],
    labels: {
      style: {
        fontSize: "12px",
        fontWeight: "bolder",
        fontFamily: "Rubik, sans-serif",
        colors: "var(--chart-text-color)",
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      borderType: "solid",
    },
    tooltip: {
      enabled: false,
    },
  },
  legend: {
    show: false,
  },
  yaxis: {
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    labels: {
      style: {
        fontSize: "14px",
        fontWeight: "bolder",
        fontFamily: "Secular One",
        colors: "$black",
      },
    },
  },
  tooltip: {
    custom: function ({ series, seriesIndex, dataPointIndex, w }) {
      return '<ul class="p-2">' + "<li><b>Oreder</b>: " + w.globals.labels[dataPointIndex] + "</li>" + "</ul>";
    },
  },
  grid: {
    borderColor: "var(--chart-dashed-border)",
  },
  colors: [lightcolor, lightcolor, lightcolor, lightcolor, lightcolor, lightcolor, darkcolor, lightcolor, lightcolor, lightcolor, lightcolor],
};